/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class SoundingApi extends runtime.BaseAPI {
    /**
     * Computes convective parameters (LCL, LFC, EL, CAPE, CIN, parcel profile) based on input temperature, dewpoint and pressure profile.
     * Get Sounding
     */
    async v2GetSoundingRaw(requestParameters, initOverrides) {
        if (requestParameters['soundingRequest'] == null) {
            throw new runtime.RequiredError('soundingRequest', 'Required parameter "soundingRequest" was null or undefined when calling v2GetSounding().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        let urlPath = `/api/v2/sounding/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['soundingRequest'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Computes convective parameters (LCL, LFC, EL, CAPE, CIN, parcel profile) based on input temperature, dewpoint and pressure profile.
     * Get Sounding
     */
    async v2GetSounding(requestParameters, initOverrides) {
        const response = await this.v2GetSoundingRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
